module.exports = __webpack_public_path__ + "static/media/LP3.4ef5d28b.svg";